import { render, staticRenderFns } from "./multi-radio-button.component.vue?vue&type=template&id=162e1a90"
import script from "./multi-radio-button.component.ts?vue&type=script&lang=ts&external"
export * from "./multi-radio-button.component.ts?vue&type=script&lang=ts&external"
import style0 from "./multi-radio-button.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports